import React from "react";
import { Badge } from "reactstrap";
import style from "./IO.module.scss";
import { TransactionStatus, IOType as TIOType, IOTransferType } from "./types";
import { FormattedNumber } from "../FormattedNumber/FormattedNumber";
import { renderOrderStatus } from "../Order/Item";

const IOType = (ioType) => (
  <Badge className={`${style.badge} ${style[ioType.toLowerCase()]}`}>{ioType.toUpperCase()}</Badge>
);

const Status = (status) => renderOrderStatus({ OrderStatus: status });

/* quantity */
const Quantity = (quantity) => (
  <span className={style.bold}>
    <FormattedNumber value={quantity} dataTypeDecimalName="quantity" />
  </span>
);

/* symbol */
const Symbol = ({ IsCurrency, AssetTicker, CurrencyISO }) => (
  <span className={style.bold}>{IsCurrency ? CurrencyISO : AssetTicker}</span>
);

const LocalOrINTL = (local) => (
  <Badge color="primary" style={{ minWidth: "36px" }} className={style.badge}>
    {local ? "Local" : "INTL"}
  </Badge>
);

const Account = (transaction, opsViewAccountName) => {
  if (transaction.IOType == TIOType.Transfer) {
    return(
      <span>
        {opsViewAccountName == undefined ? 
        (
          transaction.transfersendingName + " " + transaction.transfersendingNumber + "/" + transaction.transferreceivingName + " " + transaction.transferreceivingNumber
        )
        :
        (
          opsViewAccountName ?
          (
            transaction.transfersendingName + " " + transaction.transfersendingNumber + "/" + transaction.transferreceivingName + " " + transaction.transferreceivingNumber
          )
          :
          (
            transaction.transfersendingNumber + "/" + transaction.transferreceivingNumber
          )
        )
        }
      </span>
    )
  }
  else{
    return (
      <span>
        {opsViewAccountName == undefined ? 
        (
          transaction.items[0].AccountName + "/" + transaction.items[0].AccountNumber
        )
        :
        (
          opsViewAccountName ?
          (
            transaction.items[0].AccountName + "/" + transaction.items[0].AccountNumber
          )
          :
          (
            transaction.items[0].AccountNumber
          )
        )
        }
      </span>
    );
  }

  return (
    <span>
      {opsViewAccountName && transaction.items[0].AccountName}
      {"/"}
      <span className={style.bold}>{transaction.items[0].AccountNumber}</span>
    </span>
  );
};

const BankAccount = (transaction) => {
  if (
    (transaction.IOType == TIOType.Deposit && transaction.items[0].IsCurrency) ||
    (transaction.IOType == TIOType.Withdraw && transaction.items[0].IsCurrency)
  ) {
    return (
      <span color="primary">
        [
        {transaction.items[0].TransferType == IOTransferType.Transfer
          ? `${transaction.items[0].BankAccountName} - ${transaction.items[0].BankAccountNumber}`
          : `${transaction.items[0].TransferType}`}
        ]
      </span>
    );
  }

  return null;
};

const Product = (transaction) => {
  if (transaction.IOType == TIOType.Transfer && transaction.items.length > 1) {
    return "-";
  }

  return transaction.items[0].IsCurrency ? "CASH" : "ASSET";
};

export { IOType, Status, Quantity, Symbol, Account, BankAccount, Product, LocalOrINTL };
